import { plumeAPI } from "@/src/helpers/ServiceHelper";
import { logoutOnAuthError } from "@/src/helpers/authErrors";
import { captureEvent } from "@/src/helpers/trackEvent";

export function handlePayment(plan, user, router, setError, setIsLoading, getAccessTokenSilently, logout) {
  captureEvent("checkout_started", { plan });
  return getAccessTokenSilently()
    .then((token) => {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      setIsLoading(true);

      const body = { plan };

      return plumeAPI.post("/subscriptions_api/subscriptions/stripe/payment-link", body, config);
    })
    .then((response) => {
      if (response.data.url) {
        router.push(response.data.url); // Redirect to Stripe's checkout page
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error:", error);
      captureEvent("checkout_link_failed", { plan, message: error?.message });

      if (!logoutOnAuthError(error, logout)) {
        // Handle non-auth errors
        const errorMessage = error.response?.data?.error?.message || error.message || "An unknown error occurred";
        setError(new Error(errorMessage));
        setTimeout(() => {
          setError(null);
        }, 5000);
      }

      throw error; // Re-throw for caller to handle if needed
    })
    .finally(() => {
      setIsLoading(false);
    });
}

export function handleManageAccount(subscription, router, setError, setIsLoading, getAccessTokenSilently, logout) {
  if (!subscription) {
    setError(new Error("No subscription found"));
    return Promise.reject(new Error("No subscription found"));
  }

  return getAccessTokenSilently()
    .then((token) => {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      setIsLoading(true);

      const body = { customerId: subscription.stripe_customer_id };

      return plumeAPI.post("/subscriptions_api/subscriptions/stripe/customer-portal-link", body, config);
    })
    .then((response) => {
      if (response.data.url) {
        captureEvent("billing_portal_opened", { plan: subscription.subscription_type });
        router.push(response.data.url); // Redirect to Stripe's customer portal
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error:", error);
      captureEvent("billing_portal_failed", { plan: subscription?.subscription_type, message: error?.message });

      if (!logoutOnAuthError(error, logout)) {
        // Handle non-auth errors
        const errorMessage = error.response?.data?.error?.message || error.message || "An unknown error occurred";
        setError(new Error(errorMessage));
        setTimeout(() => {
          setError(null);
        }, 5000);
      }

      throw error; // Re-throw for caller to handle if needed
    })
    .finally(() => {
      setIsLoading(false);
    });
}
